import { render, staticRenderFns } from "./ProfilesShow.vue?vue&type=template&id=bf8fd088&scoped=true"
import script from "./ProfilesShow.vue?vue&type=script&lang=js"
export * from "./ProfilesShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8fd088",
  null
  
)

export default component.exports